/**
 * @generated SignedSource<<3c87fb2860e1dc55df0fd8982d5e73f2>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateSchedulePayload",
            "kind": "LinkedField",
            "name": "updateSchedules",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfSchedule",
                    "kind": "LinkedField",
                    "name": "scheduleEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Schedule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleSortModal_updateSchedulesMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleSortModal_updateSchedulesMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "19b4e6c3efa53f1661263f4095135f69",
            "id": null,
            "metadata": {},
            "name": "ScheduleSortModal_updateSchedulesMutation",
            "operationKind": "mutation",
            "text": "mutation ScheduleSortModal_updateSchedulesMutation(\n  $model: [UpdateScheduleRequestInput!]!\n) {\n  updateSchedules(model: $model) {\n    scheduleEdge {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "c7bb50c110ffaa563b590d2679a3444c";
export default node;
